/**
 * ============================================================
 * Home.js — Synlab Homepage
 * ============================================================
 *
 * Displays:
 *   - Header image with title overlay
 *   - Vimeo demo reel
 *   - Synlab description text
 **/

import React from "react";
import { Container } from "react-bootstrap";
import SynlabNavbar from "../components/SynlabNavbar";
import SynlabFooter from "../components/SynlabFooter";

import "./css/Page.css";   // global page layout
import "./css/Home.css";   // page-specific styling


// ------------------------------------------------------------
// Component
// ------------------------------------------------------------
function Home() {
  return (
    <div className="page-wrapper">

      {/* ----- NAVBAR ----- */}
      <header className="header">
        <SynlabNavbar />
      </header>

      {/* ----- FLEX COLUMN WRAPPER ----- */}
      <div className="inner-page-wrapper">

        {/* ----- HEADER IMAGE + TITLE OVERLAY ----- */}
        <div className="header-image-container">
          <img
            src="/headers/Header_home.png"
            alt="Synlab Header"
            className="header-image"
          />
          <h1 className="header-title">Synaesthetic Media Lab</h1>
        </div>

        {/* ----- MAIN CONTENT ----- */}
        <section className="page-content">
          <Container fluid="lg" className="px-0">

            <div className="home-inner">

              {/* ----- SYNLAB DEMO REEL ----- */}
              <iframe
                src="https://player.vimeo.com/video/302177919?h=3099c39328"
                className="home-video"
                title="Synlab Demo Reel"
                allow="autoplay; fullscreen; picture-in-picture"
              ></iframe>

              {/* ----- SYNLAB DESCRIPTION ----- */}
              <p className="body-text">
                The Synaesthetic Media Lab (Synlab) at Toronto Metropolitan
                University explores emerging modalities in computational media.
                Our research focuses on how tangible and embodied interactions can
                support creativity and discovery across the physical and digital
                worlds. Synlab researchers design, develop, and study interactive
                tools and environments to help people think, learn, and create
                across diverse domains, from the computational sciences to media
                arts, education, and entertainment. Synlab was founded in 2005 and
                was initially located in Georgia Tech’s GVU Center in Atlanta, GA.
              </p>
            </div>
            
          </Container>
        </section>

      </div>

      {/* ----- FOOTER ----- */}
      <SynlabFooter />
    </div>
  );
}

export default Home;
